import { render, staticRenderFns } from "./TypeOfCalendarOverviewMenu.vue?vue&type=template&id=6918c33a&scoped=true&"
import script from "./TypeOfCalendarOverviewMenu.vue?vue&type=script&lang=js&"
export * from "./TypeOfCalendarOverviewMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6918c33a",
  null
  
)

export default component.exports